import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from './../../auth/session/session.service';

@Component({
  selector: 'nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {

  userRoles: string[] | undefined;
  token: any;
  showAiNoc = false;

  links: Link[] = [
    {
      name: 'Status Report',
      path: '/statusreport',
      active: false,
      hidden: true,
      groups: [
        'DeviceMonitoringWriter',
        'DeviceMonitoringReader',
        'DeviceMonitoringAdmin'
      ]
    },
    {
      name: 'Insights',
      path: '/insights',
      active: false,
      hidden: true,
      groups: [
        'DeviceMonitoringWriter',
        'DeviceMonitoringReader',
        'DeviceMonitoringAdmin'
      ]
    },
    {
      name: 'Profiles',
      path: '/profiles',

      active: false,
      hidden: true,
      groups: [
        'DeviceMonitoringWriter',
        'DeviceMonitoringReader',
        'DeviceMonitoringAdmin'
      ]
    },
    {
      name: 'Map',
      path: '/map',
      active: false,
      hidden: true,
      groups: [
        'DeviceMonitoringWriter',
        'DeviceMonitoringReader',
        'DeviceMonitoringAdmin'
      ]
    },
    {
      name: 'Syslogs',
      path: '/syslogs',

      active: false,
      hidden: true,
      groups: [
        'SysLogReader',
        'SysLogAdmin',
        'SysLogWriter',
        'SysLogReader',
        'SysLogAdmin',
        'SysLogWriter']
    },
    {
      name: 'OpenSearch',
      path: '/dashboards',
      active: false,
      hidden: true,
      groups: [
        'DeviceMonitoringWriter',
        'DeviceMonitoringReader',
        'DeviceMonitoringAdmin'
      ]
    },
    {
      name: '|',
      path: null,
      active: true,
      hidden: false,
      disabled: true,
      groups: [
        'DeviceCommandWriter',
        'DeviceCommandReader',
        'DeviceCommandAdmin',
        'BulkSettingRequester',
        'BulkSettingReviewer',
        'BulkSettingReader'
      ]
    },
    {
      name: 'Commands',
      path: '/commands',
      active: false,
      hidden: true,
      groups: [
        'DeviceCommandWriter',
        'DeviceCommandReader',
        'DeviceCommandWriter',
        'DeviceCommandReader',
        'DeviceCommandAdmin'
      ]
    },
    {
      name: 'Settings',
      path: '/settings',
      active: false,
      hidden: true,
      groups: [
        'BulkSettingRequester',
        'BulkSettingReviewer',
        'BulkSettingReader'
      ]
    },
    {
      name: '|',
      path: null,
      active: true,
      hidden: true,
      disabled: true,
      groups: [
        'FirmwareAdmin',
        'FirmwareReader',
        'FirmwareWriter',
        'ModuleUpdateAdmin',
        'ModuleUpdateReader',
        'ModuleUpdateWriter'
      ]
    },
    {
      name: 'Modules',
      path: '/modules',
      active: false,
      hidden: true,
      groups: [
        'FirmwareAdmin',
        'FirmwareReader',
        'FirmwareWriter',
        'ModuleUpdateAdmin',
        'ModuleUpdateReader',
        'ModuleUpdateWriter'
      ]
    },
    {
      name: 'Releases',
      path: '/releases',
      active: false,
      hidden: true,
      groups: [
        'FirmwareAdmin',
        'FirmwareReader',
        'FirmwareWriter',
        'ModuleUpdateAdmin',
        'ModuleUpdateReader',
        'ModuleUpdateWriter'
      ]
    },
    {
      name: 'Cohorts',
      path: '/cohorts',
      active: false,
      hidden: true,
      groups: [
        'FirmwareAdmin',
        'FirmwareReader',
        'FirmwareWriter',
        'ModuleUpdateAdmin',
        'ModuleUpdateReader',
        'ModuleUpdateWriter'
      ]
    }
  ]

  constructor(private router: Router, private sessionService: SessionService
  ) { }

  async ngOnInit() {

    this.userRoles = this.sessionService.getCurrentSession()!.groups;
    let path = window.location.pathname;
    this.links.forEach(link => {
      this.links.forEach(link => {
        link.active = path === link.path;
        if (link.groups?.some(val => this.userRoles?.includes(val))) {
          link.hidden = false
        }
      });
    });

    this.showAiNoc = [
      'DeviceMonitoringWriter',
      'DeviceMonitoringReader',
      'DeviceMonitoringAdmin',
    ].some(role => this.userRoles?.includes(role));
  }

  onClick(link: Link): void {
    if (!link.disabled) {
      this.router.navigateByUrl(link.path);
    }
  }

  logOut(): void {
    this.sessionService.clearSession();
    location.href = 'https://lytx.okta.com';
  }
}

interface Link {
  name: string;
  path: string;
  active: boolean;
  hidden: boolean;
  disabled?: boolean;
  groups?: string[]
}

